
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 8 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  transform: "rotate(180)"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrow_50da41111fff5c4b__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.74 10.456a.874.874 0 0 1-.067 1.304 1.063 1.063 0 0 1-1.323.019l-.09-.081-5-5.077a.87.87 0 0 1-.08-1.15l.08-.092 5-5.077A1.06 1.06 0 0 1 6.673.24a.873.873 0 0 1 .146 1.214l-.08.09-4.388 4.455 4.389 4.457Z",
  fill: "#000"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow_50da41111fff5c4b__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-light, #f9f3fb)",
  d: "M0 0h8v12H0z"
})))));

      const __svgRaw = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 8 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" transform=\"matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)\">\r\n<g clip-path=\"url(#clip0_5118_7459)\">\r\n<path d=\"M6.73993 10.456C7.11144 10.8332 7.08132 11.417 6.67267 11.7599C6.29544 12.0765 5.72754 12.0772 5.3502 11.7787L5.26005 11.6978L0.26006 6.62093C-0.057791 6.29819 -0.0842788 5.81948 0.180597 5.47074L0.26006 5.37907L5.26005 0.302154C5.63156 -0.0750677 6.26401 -0.102868 6.67267 0.240062C7.04989 0.556611 7.10457 1.0784 6.81855 1.4535L6.73993 1.54401L2.351 5.99908L6.73993 10.456Z\" fill=\"black\"></path>\r\n</g>\r\n<defs>\r\n<clipPath id=\"clip0_5118_7459\">\r\n<rect width=\"8\" height=\"12\" fill=\"var(--theme-light, #f9f3fb)\"></rect>\r\n</clipPath>\r\n</defs>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/arrow.50da41111fff5c4b3a8122dba1d60eae.svg"),
        {
          React: SvgArrow,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      